import { Col, Row } from 'react-bootstrap';

const ReferenceQuestionnaire = ({ position, register, errors }) => {
  const referenceQuestions = [
    {
      label:
        'Can you confirm that the candidate’s job title and employment dates are correct? If not, provide accurate dates.',
      name: 'confirm_dates',
    },
    {
      label:
        'Would you rehire the candidate if given the opportunity? Why or why not in one sentence?',
      name: 'hire',
    },
    {
      label:
        "What are the candidate's key strengths? What areas need improvement?",
      name: 'key_strengths',
    },
    {
      label:
        'How would you rate their reliability and dependability in one sentence? Would you say they were the first or last on the job?',
      name: 'consistency',
    },
    {
      label:
        'Describe how the candidate interacted with co-workers, supervisors, and clients/customers.',
      name: 'work_ethic',
    },
    {
      label:
        'What do you wish you knew about the candidate before you hired them?',
      name: 'prior_knowledge',
    },
    {
      label:
        'Based on your experience, why or why not do you believe this candidate would be a good fit for this position?',
      name: 'reason_good_fit',
    },
  ];

  return (
    <>
      <div className='referenceCheckSection'>
        <Row className='show-grid'>
          {referenceQuestions.map(({ label, name }) => (
            <Col key={name}>
              <p>{label}</p>
              <input
                type='text'
                {...register(`${name}_${position}`)}
                className={`${errors?.[`${name}_${position}`]?.message ? 'error' : ''}`}
              />
            </Col>
          ))}
        </Row>
      </div>

      <Col className='col_note'>
        <p>Notes</p>
        <textarea
          {...register(`ref_${position}_notes`)}
          className={`${errors?.[`ref_${position}_notes`]?.message ? 'error' : ''}`}
        ></textarea>
        <span className='text-area-error-msg'>
          {errors?.[`ref_${position}_notes`]?.message}
        </span>
      </Col>
    </>
  );
};

export default ReferenceQuestionnaire;
